<script>

    export let w = 400
    export let h = 600
    export let tile = 50
    export let circle = false

    let text="But a slow, deeply satisfied smile came over him, and his breath quickened. 'So softly it starts,' he whispered. 'Foolishly clever and with an unsurvivable trust. It just saved your miserable life, that questionable show of thought, my itchy-witch.' Al’s smile shifted, becoming lighter. 'And now you will live to possibly regret it."
        
        //divide the space up equally
    
    
    let rows = Math.ceil(h/tile)
    let cols = Math.ceil(w/tile)

   let sins1 = {
    "A": "Apathy",
    "B": "Bitterness",
    "C": "Coveting stuff",
    "D": "Drunkenness",
    "E": "Making stuff up",
    "F": "Unrepentance",
    "G": "Greediness",
    "H": "Hypocrisy",
    "I": "Ignorance",
    "J": "Jealousy",
    "K": "Kleptomania",
    "L": "Lustfulness",
    "M": "Murder",
    "N": "Neglect",
    "O": "Objectification",
    "P": "Pridefullness",
    "Q": "Quarrelsomeness",
    "R": "Stealing stuff",
    "S": "Selfishness",
    "T": "Thoughtlessness",
    "U": "Unforgiveness",
    "V": "Vanity",
    "W": "Workoholism",
    "X": "Xenophobia",
    "Y": "Yelling obscenities",
    "Z": "Zenlessness",
    "0": "Abuse",

    
}
let sins2 = {
    "A": "Abuse",
    "B": "General badness",
    "C": "Cheating",
    "D": "Deceit",
    "E": "Egocentricity",
    "F": "Foulness",
    "G": "Muckraking",
    "H": "Hatred",
    "I": "Impurity",
    "J": "Jackassery",
    "K": "Kicking against the pricks",
    "L": "Leering",
    "M": "Misery",
    "N": "Nastiness",
    "O": "Obsessing",
    "P": "Pettiness",
    "Q": "Quitting",
    "R": "Resentment",
    "S": "Slothfullness",
    "T": "Bullying",
    "U": "Uncompassion",
    "V": "Vengence",
    "W": "Wretchedness",
    "X": "Extremism",
    "Y": "Lying too much",
    "Z": "Zealotry"
}
    
    let letters = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","0","1","2","3","4","5","6","7","8","9"] 

    let fullw = tile*cols
    let fullh = tile* rows
    
    let xshift = fullw-w
    let yshift = fullh-h

   
     
    function randomColor(){
            return ("rgba(0,0,0,"+Math.random()+")" );
        }
        
        function randomNumber() {
            return Math.floor(Math.random() * 360);
        }
        
    
    </script>
    
    <svg viewbox="0 0 {w} {h}">
    <rect width="{w}" height="{h}" x=0 y=0 fill="#eee"/>
        
        {#each Array(rows) as _, i}
            {#each Array(cols) as _, ii}
            {#if !circle}
            
            <g transform="translate({(tile*ii)-(xshift/2)} {(tile*i)-(yshift/2)})">	
                    <rect width="{tile}" height="{tile}" x=0 fill="{randomColor()}"/>
                    <text style="font:bold 12px sans-serif;fill:#fff;" text-anchor="middle" x="{tile/2}" y="-{tile/3}" >{letters[Math.floor(Math.random() * 36)]}</text>
            </g>
    
                    {:else}
                    <g transform="translate({(tile*ii)+(tile/2)} {(tile*i)+(tile/2)})">	
                    <circle r="{tile/2}" x={tile/2} y=0 fill="{randomColor()}"   />
                    </g>
                
            {/if}
                    
                
            {/each}	
        {/each}
    </svg>
    
    